// QR Menü Seçimi (Hızlı Satış ekran ayarları › Mutfak Entegrasyonu) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.qrMenuSelection';

export const qrMenuSelectionGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Mutfak ekranı için menü nasıl seçilir?'),
  intro: t(`${G}.intro`, 'Bu pencere, ekran ayarlarının "Ek Ayarlar" sekmesinde "Mutfak Entegrasyonu" açılınca çıkar. Seçeceğiniz QR menüye ait mutfak ekranında, bu hızlı satış ekranından yapılan tüm satışlar görüntülenir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Menü Seçimi'),
    body: t(`${G}.regions.body`, 'QR menü listesi'),
    footer: t(`${G}.regions.footer`, 'İptal / Menüyü Seç'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Menüyü seçin'),
      text: t(`${G}.s1.text`, 'Listede şirketinizin QR menüleri, adı ve şubesiyle görünür. Satırın kendisine ya da soldaki yuvarlak düğmeye dokunarak menüyü seçin; seçilen satırda "Seçildi" yazar.'),
      tips: [
        t(`${G}.s1.tip1`, 'Satışları görmek istediğiniz mutfak ekranının bağlı olduğu QR menüyü seçin.'),
        t(`${G}.s1.tip2`, '"QR Menü Bulunamadı" yazıyorsa önce QR Menüler sayfasından bir menü oluşturun.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s2.title`, '2. Menüyü Seç'),
      text: t(`${G}.s2.text`, '"Menüyü Seç" düğmesine basın (menü seçilmeden düğme "Lütfen Menü Seçin" yazar ve kapalıdır). Seçtiğiniz menünün adı "Mutfak Entegrasyonu" kutusunda görünür; "Değiştir" ile başka menü seçebilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Seçim, ekran ayarlarını kaydettiğinizde geçerli olur.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s3.title`, '3. Vazgeçmek isterseniz'),
      text: t(`${G}.s3.text`, '"İptal" ya da çarpı pencereyi kapatır. Daha önce seçili bir menü yoksa "Mutfak Entegrasyonu" da kapanır; mutfak entegrasyonu açıkken QR menü seçmeden ayarlar kaydedilemez.'),
    },
  ],
});
